import { NexusErrorMessage } from '@nexus/react';
import { MotifRadioButton } from '@ey-xd/motif-react';
import * as React from 'react';

interface InputProps {
    input?: any;
    label?: string;
    options: {
        label: string;
        value: string;
        disabled?: boolean;
    }[];
    meta?: {
        touched: boolean;
        error: boolean;
    };
    selectedValue?: string;
    name?: string;
}

export const RadioComponent: React.FC<InputProps> = (props: InputProps) => {
    const isError = props?.meta?.touched && props?.meta?.error;

    const handleChange = (selected: string) => {
        props?.input?.onChange?.(selected);
    };

    return (
        <>
            {props.options.map(
                (
                    option: {
                        label: string;
                        value: string;
                        disabled?: boolean;
                    },
                    index: number,
                ) => {
                    return (
                        <div
                            key={option.value + index}
                            style={{ paddingRight: index === props.options.length - 1 ? 0 : '1rem' }}
                        >
                            <MotifRadioButton
                                data-testid={option.label}
                                {...props.input}
                                className='ey-radio-button'
                                name={props?.input?.name ? props?.input?.name : props.name}
                                value={option.value}
                                checked={option.value === props?.selectedValue}
                                disabled={option.disabled}
                                onChange={() => handleChange(option.value)}
                            >
                                {option.label}
                            </MotifRadioButton>
                        </div>
                    );
                },
            )}
            {isError && <NexusErrorMessage>{props?.meta?.error}</NexusErrorMessage>}
        </>
    );
};

export default RadioComponent;
